import { Link, Outlet } from "react-router-dom";

import { LOGO_URL } from "@/lib/constants";
import {
  AndroidIcon,
  AppleIcon,
  BrandedExperienceIcon,
  IphoneIcon,
  PrivateByDesignIcon,
  PushNotificationsIcon,
  TabletIcon,
  WatchIcon,
  WidgetsIcon,
} from "@/components/auth/brand-icons";

const PLATFORMS = [
  { Icon: AppleIcon, name: "Apple" },
  { Icon: AndroidIcon, name: "Android" },
  { Icon: IphoneIcon, name: "iPhone" },
  { Icon: TabletIcon, name: "tablet" },
  { Icon: WatchIcon, name: "Apple Watch" },
];

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col lg:grid lg:grid-cols-2">
      <main className="flex flex-1 flex-col px-6 pt-10">
        <div className="mx-auto w-full max-w-[360px]">
          <Link to="/login" className="inline-flex items-center gap-2.5">
            <img src={LOGO_URL} alt="" className="h-8 w-auto" />
            <span className="text-xl font-semibold">Appio</span>
          </Link>
        </div>

        <div className="flex flex-1 items-center justify-center py-12">
          <div className="w-full max-w-[360px]">
            <Outlet />
          </div>
        </div>
      </main>

      <aside className="relative hidden items-center overflow-hidden bg-brand-panel px-12 py-12 text-primary-foreground lg:flex">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.08] via-transparent to-transparent"
        />

        <div className="relative z-10 mx-auto w-full max-w-lg">
          <h1 className="text-balance text-4xl font-semibold leading-[1.1] tracking-tight">
            No mobile app, no problem
          </h1>
          <p className="mt-4 text-pretty leading-relaxed text-primary-foreground/70">
            The easiest way to offer mobile features without building mobile apps.
          </p>

          <div className="mt-4 flex items-center gap-3 text-primary-foreground/70">
            <span>Works on</span>
            <span className="sr-only">
              Apple, Android, iPhone, tablet, and Apple Watch
            </span>
            <span className="flex items-center gap-3">
              {PLATFORMS.map(({ Icon, name }) => (
                <Icon key={name} className="h-5 w-auto" />
              ))}
            </span>
          </div>

          <ul className="mt-5 space-y-3.5 text-sm text-primary-foreground/80">
            <li className="flex items-center gap-3">
              <PushNotificationsIcon className="h-4 w-4 shrink-0" />
              Push notifications
            </li>
            <li className="flex items-center gap-3">
              <WidgetsIcon className="h-4 w-4 shrink-0" />
              Widgets and complications
            </li>
            <li className="flex items-center gap-3">
              <BrandedExperienceIcon className="h-4 w-4 shrink-0" />
              Fully branded experience
            </li>
            <li className="flex items-center gap-3">
              <PrivateByDesignIcon className="h-4 w-4 shrink-0" />
              Private by design
            </li>
          </ul>
        </div>
      </aside>
    </div>
  );
}
